<input 
    #inputElement
    matInput 
    [formControl]="formControl" 
    [matAutocomplete]="auto"
    placeholder="Enter/Select"
/>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" class="custom-separator-autocomplete-panel">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value">
        {{ option.text }}
    </mat-option>
</mat-autocomplete>
